export default __webpack_public_path__ + "static/media/contactMap.893d80db.png";